import React from 'react';
import {
  IdTh,
  NameTh,
  AdressTh,
  DateTh
} from './table/requestTable.styled';
import OrderContainer from '@bit/wavfichacerta.fichacerta.tables.order-container';
import SortableColumnHeader from './table/SortableColumnHeader';
import {
  LocacoesThId,
  LocacoesThCodigo,
  LocacoesThEndereco,
  LocacoesThPretendentes,
  LocacoesThData,
  LocacoesThOrigem
} from './table/locacoesTablePrimitives.styles';

const RequestsHeader = ({ current, sort, sortHandler, modern }) => {
  if (modern) {
    return (
      <tr>
        <LocacoesThId>
          <SortableColumnHeader
            tag="id"
            current={current}
            sort={sort}
            changeCurrent={sortHandler}
          >
            ID-FC
          </SortableColumnHeader>
        </LocacoesThId>
        <LocacoesThCodigo>
          <SortableColumnHeader
            tag="cod_imovel"
            current={current}
            sort={sort}
            changeCurrent={sortHandler}
          >
            CÓD. IMÓVEL
          </SortableColumnHeader>
        </LocacoesThCodigo>
        <LocacoesThEndereco>Endereço</LocacoesThEndereco>
        <LocacoesThPretendentes>Pretendentes</LocacoesThPretendentes>
        <LocacoesThData>
          <SortableColumnHeader
            tag="data"
            current={current}
            sort={sort}
            changeCurrent={sortHandler}
          >
            Data de Inclusão
          </SortableColumnHeader>
        </LocacoesThData>
        <LocacoesThOrigem>Origem</LocacoesThOrigem>
      </tr>
    );
  }

  return (
    <tr>
      <IdTh>
        <OrderContainer
          tag="id"
          current={current}
          sort={sort}
          changeCurrent={sortHandler}
        >
          ID-FC
        </OrderContainer>
      </IdTh>
      <DateTh>
        <OrderContainer
          tag="cod_imovel"
          current={current}
          sort={sort}
          changeCurrent={sortHandler}
        >
          CÓD. IMÓVEL
        </OrderContainer>
      </DateTh>
      <AdressTh>Endereço</AdressTh>
      <NameTh>Pretendentes</NameTh>
      <DateTh>
        <OrderContainer
          tag="data"
          current={current}
          sort={sort}
          changeCurrent={sortHandler}
        >
          Data de Inclusão
        </OrderContainer>
      </DateTh>
      <DateTh>Origem</DateTh>
    </tr>
  );
};

export default RequestsHeader;
